import SeoPageLayout from "@/components/SeoPageLayout";

const KabaretNaUrodzinyFirmy = () => (
  <SeoPageLayout title="Kabaret na urodziny firmy - świętuj z humorem">
    <p>
      Urodziny firmy to doskonała okazja do świętowania sukcesów i budowania ducha zespołu. Kabaret na urodziny firmy to elegancka i zabawna atrakcja, która sprawi, że ten wyjątkowy dzień zostanie w pamięci wszystkich pracowników i gości.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Jak świętować urodziny firmy z kabaretem?</h2>
    <p>
      Występ kabaretowy na urodzinach firmy może nawiązywać do historii organizacji, jej osiągnięć i zabawnych sytuacji z życia firmowego. To personalizowany program, który sprawia, że każdy uczestnik czuje się częścią wspólnej historii.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Elementy programu urodzinowego</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Humorystyczna retrospektywa - komediowy przegląd historii firmy</li>
      <li>Roast firmowy - żartobliwe żarty z firmowych tradycji</li>
      <li>Parodie i scenki - nawiązania do codzienności w biurze</li>
      <li>Toast urodzinowy - humorystyczne przemówienie okolicznościowe</li>
      <li>Interakcja z gośćmi - quizy i zabawy o firmie</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Personalizacja programu</h2>
    <p>
      Przed każdym występem na urodzinach firmy zbieramy informacje o historii organizacji, ważnych postaciach i zabawnych anegdotach. Dzięki temu program jest unikalny i trafia prosto w serca pracowników i gości.
    </p>
  </SeoPageLayout>
);

export default KabaretNaUrodzinyFirmy;
